import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FeedbackState = {
  visible: boolean;
  isLoading: boolean;
  isCapture: boolean;
  src?: string;
};

const initialState: FeedbackState = {
  visible: false,
  isLoading: false,
  isCapture: false
};

const feedbackSlice = createSlice({
  name: 'feedback-slice',
  initialState,
  reducers: {
    setFeedbackVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    setFeedbackIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFeedbackIsCapture: (state, action: PayloadAction<boolean>) => {
      state.isCapture = action.payload;
    },
    setFeedbackSrc: (state, action: PayloadAction<string | undefined>) => {
      state.src = action.payload;
    }
  }
});

export const feedbackReducer = feedbackSlice.reducer;
export const { setFeedbackSrc, setFeedbackIsCapture, setFeedbackIsLoading, setFeedbackVisible } = feedbackSlice.actions;
